import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=72c32ad6&scoped=true"
import script from "./Target.vue?vue&type=script&lang=js"
export * from "./Target.vue?vue&type=script&lang=js"
import style0 from "./Target.vue?vue&type=style&index=0&id=72c32ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c32ad6",
  null
  
)

export default component.exports